import React, { useContext, useEffect, useState } from 'react';
import { Form, Input, DatePicker, Select, Radio, Space, Spin } from 'antd';
import ButtonLink from 'components/theme_components/ButtonLink';
import { CheckOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { AuthContext } from 'components/Auth/Auth';
import FormInput from 'components/FormInput';
import IBasket from 'icons/IBasket';
import GetLabel from 'DisplayFramework/components/GetLabel';
import InputCurrency from 'components/InputCurrency';
import ParListSelect from 'components/ParListSelect';
import { FormInstance } from 'antd/lib';
import { useQuery } from 'react-query';
import { OutstandigAmountByCtridAndEffectDate } from 'services/fincontract';
import moment from 'moment';
import { toDatePickerDate } from 'utils/utilsSFS';
import BankListSelect from 'components/BankListSelect';
import CIPayerSelect from 'pages/ClientInvoice/CIDetail/components/CIPayerSelect';
import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';

type TabAcceptPaymentProps = {
    setVisible: (visible: boolean) => void;
    setmodalVisibleConfirmVisible: (visible: boolean) => void;
    mode: string;
    source: 'encours' | 'contract-detail' | 'demandes';
    dataInput: any;
    form: FormInstance
};

const TabAcceptPayment: React.FC<TabAcceptPaymentProps> = ({
    setVisible,
    setmodalVisibleConfirmVisible,
    mode,
    source,
    dataInput,
    form
}) => {


    const { isInspect } = useContext(AuthContext);
    const showRadioButtons = source !== 'encours';
    const [modalVisibleDelet, setmodalVisibleDelet] = useState(false);

    const [loading, setLoading] = useState(false);

    useEffect(() => {

        console.log('dataInput', dataInput)
        form.setFieldsValue({
            ...dataInput,
            motif: "TOTALREIM",
            event: 'tabSfsAcceptpay',
            targetStatus: "TOTAL",
            effectdate: toDatePickerDate(dataInput.reviewdatetowish),
            reimbursedamount: dataInput.finamount
        });
        // getOutstandigAmount(moment().format('YYYY-MM-DD'))
    }, [mode, dataInput, form]);


    const handleDelete = () => {
        console.log('Delete payment request');
        setVisible(false);
        setmodalVisibleDelet(false)
    };


    return (
        <Form
            form={form}
            layout="vertical"
            className="large-ant-radio-btn no-border-radius ut-wizard-form "
        >
            {showRadioButtons && (
                <FormInput name="motif" className="custom-radio-group " nolabel>
                    <Radio.Group
                        defaultValue="TOTALREIM"
                        buttonStyle="solid"
                        className="w-100"
                        // onChange={(e) => onchange(e.target.value)}
                        value="TOTALREIM"
                    >
                        <Radio.Button
                            value="PARTREIM"
                            className="text-center custom-radio-button"
                            disabled
                        >
                            <GetLabel label='partialpay' />
                        </Radio.Button>
                        <Radio.Button
                            value="TOTALREIM"
                            className="text-center custom-radio-button"
                        >
                            {/* Montant total */}
                            <GetLabel label='totalpayement' />
                        </Radio.Button>
                    </Radio.Group>
                </FormInput>
            )}

            <FormInput
                // label={
                //   mode === 'create'
                //     ? 'Date de prélèvement'
                //     : 'Date de changement de statut'
                // }
                name="effectdate"
                className="mb-4"
                extra="JJ/MM/AAAA"
                rules={[{ required: true }]}
            >
                <DatePicker
                    format="DD/MM/YYYY"
                    className="w-full no-border-radius"
                    placeholder="JJ/MM/AAAA"
                    required
                    disabled
                />
            </FormInput>


            <FormInput name="reimbursedamount" className="mb-4" rules={[{ required: true }]}>
                <InputCurrency className="no-border-radius" disabled currcode={dataInput.currcode} />
            </FormInput>

            <FormInput name="bkaccount" className="mb-4">
                {/* <Select className="no-border-radius" disabled>
                    <Select.Option value="account1">
                        XXXXXXX - Lorem Ipsum Dolor
                    </Select.Option>
                </Select> */}
                <BankAccountListSelect
                    params={{
                        tpid: dataInput?.tpidclient,
                        allowedBktype: [
                            'INOUT',
                        ],
                    }}
                />
            </FormInput>

            <FormInput
                name="reason"
                className="mb-4"
            >
                <Select className="no-border-radius">
                    <ParListSelect disabled parcode='PAYMOTIF' />
                </Select>
            </FormInput>

            <FormInput name="comments" className="mb-6" >
                <Input.TextArea rows={6} className="no-border-radius" />
            </FormInput>

            <div className="d-flex justify-between align-center pt-4">
                <div>
                    {mode === 'modify' && (
                        <ButtonLink
                            className="ut-reset-btn ut-btn-no-border no-box-shadow mr-4 btn-supp "
                            comcode="Suppdemande"
                            icon={<IBasket />}
                            onClick={() => {
                                !isInspect && setmodalVisibleDelet(true);
                            }}

                        />
                    )}
                </div>
                {/* <Space>
          <ButtonLink
            comcode={mode === 'modify' ? 'Fermer' : 'Annuler'}
            onClick={() => setVisible(false)}
            className="btn-light"
          />
          <ButtonLink
            comcode="Valider"
            type="primary"
            onClick={handleSubmit}
            className="no-border-radius"
          />
        </Space> */}
            </div>
            <ConfirmModal
                className="modalConfirmOrCancel"
                visible={modalVisibleDelet}
                status="error"
                message="Etes vous sure de vouloir supprimer ces demandes ?"
                onConfirm={
                    handleDelete
                }
                onCancel={() => {
                    !isInspect && setmodalVisibleDelet(false);
                }}
                Confirmcomcode="valider"
                Cancelcomcode='close'
            />

        </Form>
    );
};

export default TabAcceptPayment;
